import { render, staticRenderFns } from "./selectUnitType.vue?vue&type=template&id=55ed58cd&"
import script from "./selectUnitType.vue?vue&type=script&lang=js&"
export * from "./selectUnitType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports